import React from 'react'
import { FeaturesContextProvider } from '@cbgms/base/feature-flags'
import useGmsFeatures from './useGmsFeatures'
import useDatadogSetup from 'utils/Datadog/useDatadogSetup'

interface Props {
  children: React.ReactNode
}

const DatadogSetup = () => {
  useDatadogSetup()
  return null
}

const GmsFeaturesContextProvider = ({ children }: Props) => {
  const enabledGmsFeatures = useGmsFeatures()

  return (
    <FeaturesContextProvider features={enabledGmsFeatures}>
      <DatadogSetup />
      {children}
    </FeaturesContextProvider>
  )
}

export default GmsFeaturesContextProvider
